import {Link} from "react-router-dom";

function BookingSec() {
    return (
        <>
            <section className="bookingSec">
                <img src={process.env.PUBLIC_URL + "/images/bookingBg.webp"} alt="" className="bookingBg"/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <figure className="imgCont">
                                <img src={process.env.PUBLIC_URL + "/images/bookingImg.webp"} alt=""/>
                            </figure>
                        </div>
                        <div className="col-md-6">
                            <div className="content">
                                <div className="title">
                                    <h3 className="subHeading bold" data-aos='fade-up'>
                                        Contact Us
                                    </h3>
                                    <h2 className="secHeading" data-aos='fade-up' data-aos-delay='100'>
                                        Book Our Online Courses & Improve Your Skill
                                    </h2>
                                </div>
                                <p data-aos='fade-up' data-aos-delay='100'>
                                    Ready to take the next step or have questions about our programs? Get in touch with
                                    Skill Bridge. today. Your journey toward mastering DevOps begins here.
                                </p>
                                <Link data-aos-delay='150' data-aos='fade-up' to="/apply-now" className="themeBtn">Apply Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BookingSec